module.exports = __webpack_public_path__ + "static/media/Motorola Moto E Black.ff6a1727.png";